import {createApp} from 'vue'
import GroupCard from './GroupCard'

const el = '.kb-component--group-card'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((GroupCardDOM) => {
            const props = {
                content: GroupCardDOM.dataset.content ? JSON.parse(GroupCardDOM.dataset.content) : {}
            }
            const component = createApp(GroupCard, props).use(Store)
            component.mount(GroupCardDOM)
        })
    }
}